/**
 * pexelsifyUrl — accept either a direct CDN image URL or a Pexels photo
 * *page* URL (e.g. "https://www.pexels.com/photo/...-36463421/") and
 * return the actual rendered image URL.
 *
 * Pexels page URLs return an HTML document, which is why advisors who
 * paste the share-link from pexels.com see a broken image. This util
 * runs on blur in every URL field that feeds a client-facing surface.
 */
export function pexelsifyUrl(url) {
  if (!url) return "";
  const raw = String(url).trim();
  if (!raw) return "";
  const low = raw.toLowerCase();
  if (low.includes("pexels.com/photo/") && !low.includes("images.pexels.com")) {
    const m = raw.replace(/\/$/, "").match(/-(\d+)$/);
    if (m) {
      const pid = m[1];
      return `https://images.pexels.com/photos/${pid}/pexels-photo-${pid}.jpeg?auto=compress&w=1800&h=1100&dpr=2`;
    }
  }
  return raw;
}

export default pexelsifyUrl;
